import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('BookingItemStore')
@observer
class BookingCategorySearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Category',
                dataIndex: 'name',
                key: 'name',
                width: '80%'
            },
            {
                title: 'Action',
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                render: id => (
                    <span>
                        <Button onClick={() => this.selectCategoryOnClick(id)} type='primary'>
                            Select
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    categoryOnChange = e => {
        this.props.BookingItemStore.setCategorySearchValue(e.target.value);
        this.props.BookingItemStore.searchCategory();
    }

    // ON CLICK

    selectCategoryOnClick = categoryId => {
        this.props.BookingItemStore.searchCategorySelected(categoryId);
        this.props.BookingItemStore.setShowBookingCategorySearchModal(false);
    }

    render() {
        const {
            bookingCategoryFilter,
            categorySearchValue
        } = this.props.BookingItemStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Category' value={categorySearchValue} onChange={this.categoryOnChange} />
                <Table columns={this.getColumns()} dataSource={bookingCategoryFilter} />
            </React.Fragment>
        )
    }
}

export default BookingCategorySearchModalPage;
